import "./animate.css";
import "./colorpicker.css";
import "./font-awesome-6.css";
import "./fullcalendar.css";
import "./iconpicker-1.5.0.css";
import "./select.css";
// import "./select2.css";
import "./selectize.default.css";
import "./slider.css";
import "./style.css";
import "./toastr.css";
import "./ui-grid.css";
import "./ui-iconpicker.css";
import "./jquery-ui.css";
//import "./icheck_square_all.css";
//import "./bootstrap-3.4.1.css";
import "./angularjs-chips.css";
import "./angular-ui-switch.css";
import "./angular-gantt.css";
import "./angular-gantt-plugins.css";
import "./app.css";
import "./ball-pulse.css";
import "./events.css";
import "./events_mediaQueries.css";

import "./theme.css";

import "../../node_modules/primeicons/primeicons.css";
